export const CREATE_EXPERT_REVIEW_REQUEST = "CREATE_EXPERT_REVIEW_REQUEST";
export const CREATE_EXPERT_REVIEW_SUCCESS = "CREATE_EXPERT_REVIEW_SUCCESS";
export const CREATE_EXPERT_REVIEW_FAIL = "CREATE_EXPERT_REVIEW_FAIL";

export const FETCH_EXPERT_REVIEWS_FOR_EXPERT_REQUEST =
  "FETCH_EXPERT_REVIEWS_FOR_EXPERT_REQUEST";
export const FETCH_EXPERT_REVIEWS_FOR_EXPERT_SUCCESS =
  "FETCH_EXPERT_REVIEWS_FOR_EXPERT_SUCCESS";
export const FETCH_EXPERT_REVIEWS_FOR_EXPERT_FAIL =
  "FETCH_EXPERT_REVIEWS_FOR_EXPERT_FAIL";

export const FETCH_MY_EXPERT_REVIEWS_REQUEST =
  "FETCH_MY_EXPERT_REVIEWS_REQUEST";
export const FETCH_MY_EXPERT_REVIEWS_SUCCESS =
  "FETCH_MY_EXPERT_REVIEWS_SUCCESS";
export const FETCH_MY_EXPERT_REVIEWS_FAIL = "FETCH_MY_EXPERT_REVIEWS_FAIL";

export const RESET_EXPERT_REVIEWS_ERROR = "RESET_EXPERT_REVIEWS_ERROR";
